import React from 'react';

/** @returns {'all' | 'enabled' | 'disabled'} */
export const getEmbedListActiveFilterState = (value) => {
    const selected = Array.isArray(value) ? value : [];
    if (selected.length !== 1) {
        return 'all';
    }
    const v = selected[0];
    if (v === 1 || v === true || v === '1') {
        return 'enabled';
    }
    if (v === 0 || v === false || v === '0') {
        return 'disabled';
    }
    return 'all';
};

/** Cycles: all → enabled only → disabled only → all */
export const nextEmbedListActiveFilterValue = (current) => {
    const state = getEmbedListActiveFilterState(current);
    if (state === 'all') {
        return [1];
    }
    if (state === 'enabled') {
        return [0];
    }
    return [];
};

const EmbedListActiveQuickFilter = ({ value, onChange, isLoading, itemLabel = 'items' }) => {
    const state = getEmbedListActiveFilterState(value);
    const isFiltered = state !== 'all';
    const buttonLabel =
        state === 'enabled' ? 'Active: Enabled' : state === 'disabled' ? 'Active: Disabled' : 'Active';

    return (
        <button
            type="button"
            className={`btn d-flex align-items-center gap-1 ${isFiltered ? 'btn-primary' : 'btn-secondary'}`}
            style={{ fontSize: '14px', whiteSpace: 'nowrap' }}
            disabled={isLoading}
            title={
                state === 'all'
                    ? `Show enabled ${itemLabel} only`
                    : state === 'enabled'
                      ? `Show disabled ${itemLabel} only`
                      : `Show all ${itemLabel}`
            }
            onClick={() => onChange(nextEmbedListActiveFilterValue(value))}
        >
            {buttonLabel}
        </button>
    );
};

export default EmbedListActiveQuickFilter;
